import { Platform, StyleSheet } from "react-native";
import { theme } from "../../../theme/theme";
const modalStylesForColumSize = {
    ["1/4"]: {
        maxWidth: `${100 * (1 / 4)}%`,
    },
    ["1/3"]: {
        maxWidth: `${100 * (1 / 3)}%`,
    },
    ["1/2"]: {
        maxWidth: `${100 * (1 / 2)}%`,
    },
    ["2/3"]: {
        maxWidth: `${100 * (2 / 3)}%`,
    },
    ["1"]: {
        maxWidth: "100%",
    },
};
const style = () => {
    const { borderRadius4, colorBgBase, colorBgOpacity, shadowColor, shadowOffset, shadowOpacityM, shadowRadius, space4, space6, space8, space10, layoutMaxWidth, } = theme();
    const styles = StyleSheet.create({
        closeButton: {
            padding: 0,
        },
        container: {
            height: "100%",
            overflow: "hidden",
            ...Platform.select({
                web: { position: "fixed" },
                android: { position: "absolute" },
                ios: { position: "absolute" },
            }),
            width: "100%",
            zIndex: 100,
        },
        header: {
            alignItems: "center",
            flexDirection: "row",
            padding: space6,
        },
        modal: {
            backgroundColor: colorBgBase,
            borderRadius: borderRadius4,
            position: "absolute",
            width: "100%",
            zIndex: 3,
        },
        modalFullscreen: {
            borderRadius: 0,
            height: "100%",
            maxWidth: "100%",
        },
        modalSmall: {
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
        },
        overlay: {
            backgroundColor: colorBgOpacity,
            ...Platform.select({
                web: { cursor: "pointer" },
            }),
            height: "100%",
            position: "absolute",
            width: "100%",
            zIndex: 1,
        },
        row: {
            alignContent: "center",
            flex: 1,
            justifyContent: "center",
            paddingHorizontal: 0,
        },
        rowSmall: {
            justifyContent: "flex-end",
        },
        safeArea: {
            flex: 1,
            zIndex: 2,
        },
        stickyFooter: {
            paddingBottom: space6,
            paddingHorizontal: space8,
            paddingTop: space4,
            shadowColor,
            shadowOffset,
            shadowOpacity: shadowOpacityM,
            shadowRadius,
        },
        ...modalStylesForColumSize,
    });
    return {
        ...styles,
        layoutMaxWidth,
        modalDesktopVerticalPadding: space10,
        safeAreaInsetBottom: space8,
    };
};
export { style };
